export const BACKEND = 'https://amaaratv.herokuapp.com/api';
export const BACKENDAUTH = 'https://amaraapi.herokuapp.com/api';
